import { render, staticRenderFns } from "./PerSteps.vue?vue&type=template&id=00034b63&scoped=true&"
import script from "./PerSteps.vue?vue&type=script&lang=ts&"
export * from "./PerSteps.vue?vue&type=script&lang=ts&"
import style0 from "./PerSteps.vue?vue&type=style&index=0&id=00034b63&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00034b63",
  null
  
)

export default component.exports